export default __webpack_public_path__ + "static/media/information--urban-area--g1.6b606baf.png";